class ImageScrollReveal{

	constructor() {

		let images = document.querySelectorAll('.img-scroll-reveal');
		images.forEach( (image) => {
			gsap.to(image, {
				"clip-path": "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
				scrollTrigger: {
					trigger: image,
					start: "top 85%",
					end: "top 15%",
					scrub: 1
				}
			});
		});

	}

}